module.exports = __webpack_public_path__ + "static/media/gridview.92782fa4.svg";